// extracted by mini-css-extract-plugin
export var activeCategoryContainer = "PriceDetailsSection-module--activeCategoryContainer--36ebe";
export var activeTitle = "PriceDetailsSection-module--activeTitle--b1f61";
export var arrowActive = "PriceDetailsSection-module--arrowActive--35ad3";
export var categoryContainer = "PriceDetailsSection-module--categoryContainer--603bb";
export var containerExtraClass = "PriceDetailsSection-module--containerExtraClass--1e613";
export var contentContainer = "PriceDetailsSection-module--contentContainer--d696e";
export var description = "PriceDetailsSection-module--description--13549";
export var navContainer = "PriceDetailsSection-module--navContainer--5e0bf";
export var navTitle = "PriceDetailsSection-module--navTitle--84424";
export var pricingContainer = "PriceDetailsSection-module--pricingContainer--697db";
export var separator = "PriceDetailsSection-module--separator--45075";